exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrolltop[data-v-095a3d86]{background-color:#008bd0;width:20px;height:20px;display:block;position:fixed;bottom:161px;left:0;z-index:10;display:flex;align-items:center;justify-content:center;transform:rotate(-90deg)}.scrolltop img[data-v-095a3d86]{width:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-095a3d86","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/Scrolltop.vue
// module id = 420
// module chunks = 0